import { useTranslation } from 'react-i18next';
import { AiobiLogo } from '@/components/branding/AiobiLogo';
import { FilePicker } from '@/components/loading/FilePicker';
import { ReloadButton } from '@/components/layout/ReloadButton';
import { ThemeToggle } from '@/components/layout/ThemeToggle';

export function AppHeader() {
  const { t } = useTranslation();

  return (
    <header className="aiobi-header" role="banner">
      <div className="aiobi-header__brand">
        <AiobiLogo size={32} />
        <div>
          <h1 className="aiobi-header__title">{t('header.title')}</h1>
          <p className="aiobi-header__title-sub">{t('header.subtitle')}</p>
        </div>
      </div>
      <div className="aiobi-header__actions">
        <FilePicker />
        <ReloadButton />
        <ThemeToggle />
      </div>
    </header>
  );
}
